import type {BioIconProps} from '../common-types'

export function ChevronRight({fill = '#9C9C9C', ...attributes}: BioIconProps) {
  return (
    <svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.49922 7.05078L7.04844 7.50156L7.49922 7.95234C7.74818 7.70338 7.74818 7.29974 7.49922 7.05078ZM6.14688 7.50156L0.647661 13.0008C0.398696 13.2498 0.398696 13.6534 0.647661 13.9023C0.896614 14.1513 1.30027 14.1513 1.54922 13.9023L7.49922 7.95234C7.49924 7.95231 7.49922 7.95234 7.04844 7.50156C7.49922 7.05078 7.49924 7.0508 7.49922 7.05078L1.54922 1.10078C1.30027 0.851824 0.896614 0.851824 0.647661 1.10078C0.398696 1.34974 0.398696 1.75338 0.647661 2.00234L6.14688 7.50156Z"
        fill={fill}
      />
    </svg>
  )
}
